/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './button.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/shared/button/button.component';
const styles_ButtonComponent:any[] = [i0.styles];
export const RenderType_ButtonComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ButtonComponent,data:{}});
function View_ButtonComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'button',([] as any[]),
      [[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.onClick($event,0)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      i1.ɵncd((null as any),0)],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.classes;
    _ck(_v,1,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.disabled;
    _ck(_v,0,0,currVal_0);
  });
}
function View_ButtonComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'span',[['class',
      'caret']],(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
function View_ButtonComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'button',[['data-toggle',
      'dropdown'],['type','button']],[[8,'disabled',0]],(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),0,'span',[['class','caret']],(null as any),
          (null as any),(null as any),(null as any),(null as any)))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.classLists[(<any>_v.parent).context.index];
    _ck(_v,1,0,currVal_1);
  },(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.disabled;
    _ck(_v,0,0,currVal_0);
  });
}
function View_ButtonComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'li',[['class',
      'divider']],(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
function View_ButtonComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'a',[['class',
      'dropdown-menu__option']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.onClick($event,(<any>(<any>(<any>_v.parent).parent).parent).context.index,
          (<any>_v.parent).context.index)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = ((<any>_v.parent).context.$implicit.option || (<any>_v.parent).context.$implicit);
        _ck(_v,1,0,currVal_0);
      });
}
function View_ButtonComponent_10(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.option;
    _ck(_v,0,0,currVal_0);
  });
}
function View_ButtonComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ButtonComponent_8)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,
          'li',([] as any[]),[[2,'dropdown-header',(null as any)],[2,'disabled',(null as any)]],
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_ButtonComponent_9)),i1.ɵdid(16384,
          (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf'],
              ngIfElse:[1,'ngIfElse']},(null as any)),(_l()(),i1.ɵand(0,[['header',
          2]],(null as any),0,(null as any),View_ButtonComponent_10))],(_ck,_v) => {
    const currVal_0:any = (_v.context.$implicit.isHeader && (_v.context.index > 0));
    _ck(_v,2,0,currVal_0);
    const currVal_3:boolean = !_v.context.$implicit.isHeader;
    const currVal_4:any = i1.ɵnov(_v,6);
    _ck(_v,5,0,currVal_3,currVal_4);
  },(_ck,_v) => {
    const currVal_1:any = _v.context.$implicit.isHeader;
    const currVal_2:any = _v.context.$implicit.disabled;
    _ck(_v,3,0,currVal_1,currVal_2);
  });
}
function View_ButtonComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'ul',[['class',
      'dropdown-menu']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ButtonComponent_7)),
      i1.ɵdid(802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any))],(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.options;
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
function View_ButtonComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'div',[['class',
      'btn-group']],[[2,'btn-group--split',(null as any)],[2,'dropup',(null as any)]],
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),4,'button',[['type','button']],[[1,'data-toggle',
          0],[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.onClick($event,_v.context.index)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      (_l()(),i1.ɵted((null as any),['',' '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ButtonComponent_4)),i1.ɵdid(16384,(null as any),
          0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ButtonComponent_5)),i1.ɵdid(16384,(null as any),
          0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ButtonComponent_6)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_4:any = _co.classLists[_v.context.index];
    _ck(_v,2,0,currVal_4);
    const currVal_6:any = (_v.context.$implicit.options && !_v.context.$implicit.split);
    _ck(_v,5,0,currVal_6);
    const currVal_7:any = (_v.context.$implicit.options && _v.context.$implicit.split);
    _ck(_v,8,0,currVal_7);
    const currVal_8:any = _v.context.$implicit.options;
    _ck(_v,10,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = (_v.context.$implicit.options && _v.context.$implicit.split);
    const currVal_1:any = (_v.context.$implicit.options && _v.context.$implicit.dropup);
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_2:any = ((_v.context.$implicit.options && !_v.context.$implicit.split)? 'dropdown': '');
    const currVal_3:any = _v.context.$implicit.disabled;
    _ck(_v,1,0,currVal_2,currVal_3);
    const currVal_5:any = (_v.context.$implicit.options? _v.context.$implicit.text: _v.context.$implicit);
    _ck(_v,3,0,currVal_5);
  });
}
function View_ButtonComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'div',[['role',
      'group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,
          i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ButtonComponent_3)),
      i1.ɵdid(802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.groupClasses;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _co.texts;
    _ck(_v,3,0,currVal_1);
  },(null as any));
}
export function View_ButtonComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_ButtonComponent_1)),i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf'],ngIfElse:[1,'ngIfElse']},(null as any)),(_l()(),
      i1.ɵand(0,[['btnGroup',2]],(null as any),0,(null as any),View_ButtonComponent_2))],
      (_ck,_v) => {
        var _co:i3.ButtonComponent = _v.component;
        const currVal_0:boolean = !_co.texts;
        const currVal_1:any = i1.ɵnov(_v,2);
        _ck(_v,1,0,currVal_0,currVal_1);
      },(null as any));
}
export function View_ButtonComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-button',
      ([] as any[]),(null as any),(null as any),(null as any),View_ButtonComponent_0,
      RenderType_ButtonComponent)),i1.ɵdid(638976,(null as any),0,i3.ButtonComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ButtonComponentNgFactory:i1.ComponentFactory<i3.ButtonComponent> = i1.ɵccf('admin-button',
    i3.ButtonComponent,View_ButtonComponent_Host_0,{size:'size',color:'color',tag:'tag',
        colors:'colors',tags:'tags',outlined:'outlined',inverse:'inverse',disabled:'disabled',
        texts:'texts',justified:'justified',vertical:'vertical',icon:'icon'},{clickBtn:'clickBtn'},
    ['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/button/button.component.ngfactory.ts